'use client';

/**
 * HubSpot Landing Page Iframe Component
 *
 * Renders a responsive iframe for HubSpot landing pages
 * on thankyou.getscw.com. These pages use HubSpot Smart Content
 * for personalization, so they must remain as iframes.
 */

import { HUBSPOT_EMBEDS_DISABLED } from '@/lib/hubspot-embed-gate';

import { InertEmbedPlaceholder } from './InertEmbedPlaceholder';

interface HubSpotIframeProps {
  url: string;
  minHeight?: string;
  className?: string;
  title?: string;
}

export function HubSpotIframe({
  url,
  minHeight = '700px',
  className,
  title = 'SCW Contact Form',
}: HubSpotIframeProps) {
  if (HUBSPOT_EMBEDS_DISABLED) {
    return (
      <div className={className} style={{ width: '100%' }}>
        <InertEmbedPlaceholder label="HubSpot page embed" detail={url} minHeight={minHeight} />
      </div>
    );
  }

  return (
    <div className={className} style={{ width: '100%' }}>
      <iframe
        src={url}
        title={title}
        style={{
          width: '100%',
          minHeight,
          border: 'none',
          overflow: 'hidden',
        }}
        loading="lazy"
        allow="forms"
      />
    </div>
  );
}
